
export const TRANSITION_TIME = "0.5s";

